import { render, staticRenderFns } from "./ProfileResume.vue?vue&type=template&id=31f46150"
import script from "./ProfileResume.vue?vue&type=script&lang=ts"
export * from "./ProfileResume.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31f46150')) {
      api.createRecord('31f46150', component.options)
    } else {
      api.reload('31f46150', component.options)
    }
    module.hot.accept("./ProfileResume.vue?vue&type=template&id=31f46150", function () {
      api.rerender('31f46150', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/profile/ProfileResume.vue"
export default component.exports